class DetailsModal extends HTMLElement {
  private detailsContainer: HTMLDetailsElement;
  private summaryToggle: HTMLElement;
  private onBodyClickEvent?: (event: Event) => void;

  constructor() {
    super();
    this.detailsContainer = this.querySelector('details') as HTMLDetailsElement;

    this.summaryToggle = this.querySelector('summary:not(#nested-summary)') as HTMLElement;
    if (this.summaryToggle) this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    this.detailsContainer.addEventListener(
      'keyup',
      (event: KeyboardEvent) => event.code.toUpperCase() === 'ESCAPE' && this.close(),
    );

    const closeButton = this.querySelector('button[type="button"]');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }
  }

  isOpen(): boolean {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event: Event): void {
    event.preventDefault();
    const target = event.target as HTMLElement;
    const details = target.closest('details');
    if (details) {
      if (details.hasAttribute('open')) {
        this.close();
      } else {
        this.open(event);
      }
    }
  }

  onBodyClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!this.contains(target) || target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open(event: Event): void {
    window.scrollTo(0, 0);
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    const target = event.target as HTMLElement;
    const details = target.closest('details');
    if (details) {
      details.setAttribute('open', 'true');
    }
    document.body.addEventListener('click', this.onBodyClickEvent);
    window.scrollLock();

    // Check if trapFocus is available globally
    type TrapFocusFunction = (focusElement: HTMLElement | null, inputElement: HTMLInputElement | null) => void;
    const trapFocusGlobal = (globalThis as unknown as { trapFocus?: TrapFocusFunction }).trapFocus;
    if (typeof trapFocusGlobal === 'function') {
      trapFocusGlobal(
        this.detailsContainer.querySelector('[tabindex="-1"]') as HTMLElement,
        this.detailsContainer.querySelector('input:not([type="hidden"])') as HTMLInputElement,
      );
    }
  }

  close(focusToggle: boolean = true): void {
    // Check if removeTrapFocus is available globally
    type RemoveTrapFocusFunction = (focusElement: HTMLElement | null) => void;
    const removeTrapFocusGlobal = (globalThis as unknown as { removeTrapFocus?: RemoveTrapFocusFunction })
      .removeTrapFocus;
    if (typeof removeTrapFocusGlobal === 'function') {
      removeTrapFocusGlobal(focusToggle ? this.summaryToggle : null);
    }
    this.detailsContainer.removeAttribute('open');
    if (this.onBodyClickEvent) {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
    window.scrollUnlock();
  }
}

customElements.define('details-modal', DetailsModal);

export default DetailsModal;
